import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';
import { AdminShell, ADMIN_MENUS, AdminSummary, AdminNotice, AdminBanners, AdminFares, AdminMembers, AdminOrders } from '../components/admin';

// 관리자 페이지(/admin) — 회원 role 'admin' 만. 구획은 ?tab= 으로 기억한다. 권한이 없으면 로그인/첫 화면으로 보낸다
const SECTIONS = { summary: AdminSummary, notice: AdminNotice, banners: AdminBanners, fares: AdminFares, members: AdminMembers, orders: AdminOrders };

function AdminPage({ loginStore }) {
  const history = useHistory();
  const location = useLocation();
  const { userInfo, logoutAndInitialUser } = loginStore;
  const [checked, setChecked] = useState(false);
  const tab = new URLSearchParams(location.search).get('tab');
  const active = ADMIN_MENUS.some((m) => m.key === tab) ? tab : 'summary';

  // /v1/me 응답이 올 때까지 기다렸다가 판정한다 (토큰 없으면 바로 로그인으로)
  useEffect(() => {
    let token = '';
    try { token = localStorage.getItem('qwdmtk') || ''; } catch (e) { token = ''; }
    if (!token) { history.replace('/login'); return; }
    if (userInfo) {
      if (userInfo.role !== 'admin') history.replace('/');
      else setChecked(true);
    }
  }, [userInfo, history]);

  if (!checked) return null;
  const Section = SECTIONS[active];
  const select = (key) => history.push({ pathname: '/admin', search: key === 'summary' ? '' : `?tab=${key}` });

  return (
    <AdminShell
      active={active}
      onSelect={select}
      user={userInfo}
      onExit={() => history.push('/')}
      onLogout={async () => { await logoutAndInitialUser('logout'); history.push('/login'); }}
    >
      <Section onSelect={select} me={userInfo} />
    </AdminShell>
  );
}

export default inject('loginStore')(observer(AdminPage));
